import { Controller } from "@hotwired/stimulus"
import "../../frontend/entrypoints/group_workshop_board.css"

export default class extends Controller {
  async connect() {
    this.connected = true
    const workshop = await import("../../frontend/entrypoints/group_workshop")
    if (!this.connected) return
    this.workshop = workshop
    workshop.initializeWorkshop(this.element)
  }

  disconnect() {
    this.connected = false
    this.workshop?.disposeWorkshop(this.element)
  }
}
